import { config } from "../appConfig";
const BASE_URL_PROD = "https://api.classplusapp.com";
const BASE_URL_PREPROD = "https://apip-preprod.classplusapp.com";

const baseURLGlobal = config?.BASE_URL
// const baseURLGlobal = BASE_URL_PREPROD;

export default baseURLGlobal;
